import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  withRouter,
  Redirect,
} from 'react-router-dom';

import {
  Grid,
  Paper,
  Typography,
} from '@material-ui/core';

import Layout from '../components/Layout';
import * as commonActions from '../../common/actions';
import classes from '../../css/getCSS';
import back01 from '../../assets/backs/back03.jpg';
import roundLogo from '../../assets/img/logos/round_logo.png';


class SelectSite extends Component {
  componentDidMount() {
    if (this.props.sites.length === 0 && !this.props.site) {
      this.props.getSites();
    }
  }

  render() {
    if (this.props.site) {
      return <Redirect to="/" />;
    }

    const containerStyles = {
      display: 'flex',
      justifyContent: 'center',
      marginTop: '100px',
      alignItems: 'center',
    };

    return (
      <Layout hideNavbar background={back01}>
        <Grid container style={containerStyles}>
          <Grid item md={6} xs={12} sm={8}>
            <Paper className={classes.card} align="center" style={{ backgroundColor: 'rgba(255, 255, 255, 0.85)' }}>
              <img src={roundLogo} alt="Anjal ane Avsar" style={{ height: '140px' }} />
              <Typography component="h2" variant="headline" align="center" className={classes.panelTitle}>Welcome to Anjal ane Avsar</Typography>
            </Paper>
          </Grid>
        </Grid>
      </Layout>
    );
  }
}


const mapStateToProps = (state) => {
  return {
    site: state.common.site,
    sites: state.common.sites,
    sitesError: state.common.sitesError,
    selectingSite: state.common.selectingSite,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getSites: () => dispatch(commonActions.getSites()),
    selectSite: site => dispatch(commonActions.selectSite(site)),
  };
};


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SelectSite));



// WEBPACK FOOTER //
// ./src/main/containers/SelectSite.js